<template>
    <div class="task-center">
        <TaskList :is-owner="false" :is-publish="false" :table-attr="{ height: '100%' }"></TaskList>
    </div>
</template>

<script>
import TaskList from "../company/new-task/TaskList.vue";

export default {
    data() {
        return {};
    },

    components: {
        TaskList,
    },
};
</script>

<style lang="scss" scoped>
.task-center {
    background-color: #fff;
    flex: 1;
    min-width: 0;
    height: 100%;

    ::v-deep(.task-center_tab) {
        border-bottom: 1px solid #d9d9d9;
        gap: 50px;
        padding-inline: 36px;

        .tab-item {
            min-width: 0;
            padding-inline: 4px;
            box-sizing: border-box;
            position: relative;

            &.active::before {
                content: "";
                position: absolute;
                bottom: 0;
                left: 0;
                height: 2px;
                width: 100%;
                background-color: #4154ea;
            }
        }
    }

    ::v-deep(.task-center) {
        gap: 28px;
    }

    ::v-deep(.task-center_container) {
        min-height: 0;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        gap: 16px;

        .container-top {
            padding-top: 0px;
            flex-shrink: 0;
        }

        .container-table {
            flex: 1;
            padding-inline: 24px;
            padding-bottom: 0;
            margin-top: 0;
            min-height: 0;
        }

        .container-pagination {
            position: relative;
            flex-shrink: 0;
        }
    }
}
</style>
